import React, { useCallback } from 'react';
import TableCell from '../../../../../../../components/TableCell';
import { TableRow } from '@material-ui/core';
import useEmployeeStats, { GetEmployeeStatsReponse } from '../hooks/useEmployeeStats';
import { numberWithSpaces } from 'src/utils/NumberUtils';

const TotalRow = () => {
  const { employeesStats } = useEmployeeStats();

  const getStatsTotal = useCallback(
    (field: keyof GetEmployeeStatsReponse) => {
      return Object.values(employeesStats).reduce((previousValue, employeeStat) => {
        return previousValue + parseFloat(employeeStat[field] || '0');
      }, 0);
    },
    [employeesStats]
  );

  const getDealsConvertionTotal = useCallback((): string => {
    const won = getStatsTotal('dealsWonCount');
    const lost = getStatsTotal('dealsLostCount');

    if (won + lost === 0) {
      return '0';
    }

    return ((won / (won + lost)) * 100).toFixed(2);
  }, [employeesStats]);

  return (
    <TableRow>
      <TableCell>
        <strong>Total</strong>
      </TableCell>
      <TableCell>{getStatsTotal('appointmentDoneCount')}</TableCell>
      <TableCell>{getStatsTotal('customersCreatedCount')}</TableCell>
      <TableCell>{getStatsTotal('dealsCreatedCount')}</TableCell>
      <TableCell>{numberWithSpaces(getStatsTotal('dealsCreatedPDC'))}€</TableCell>
      <TableCell>{getStatsTotal('dealsWonCount')}</TableCell>
      <TableCell>{numberWithSpaces(getStatsTotal('dealsWonPDC'))}€</TableCell>
      <TableCell>{getStatsTotal('dealsLostCount')}</TableCell>
      <TableCell>{getDealsConvertionTotal()}</TableCell>
      <TableCell />
    </TableRow>
  );
};

export default TotalRow;
